import WaybillsTableColumnCourier from './index.vue'
export default WaybillsTableColumnCourier